import { AuthService } from "../libs/Auth";
import { TokenService } from "../services/TokenService";

export class LoggedOutCtrl {
    public url: string;
    public static $inject = ['$scope', 'AuthService', 'TokenService', 'localStorageService'];
    constructor(public $scope: any,
        public authService: AuthService,
        public tokenService: TokenService) {
        $scope.vm = this;
    }

    login() {
        this.authService.login();
    }
}
